import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { FieldLabel } from '../../../components/ui';

// Chips + an inline input. Enter, comma or blur adds; the model lowercases and
// de-duplicates. `suggestions` are the tags already in use (ReleaseNote/Tags).
const TagsInput = ({ tags, onAdd, onRemove, suggestions = [] }) => {
  const [draft, setDraft] = useState('');
  const commit = () => {
    if (draft.trim()) onAdd(draft);
    setDraft('');
  };
  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      commit();
    } else if (e.key === 'Backspace' && !draft && tags.length) {
      onRemove(tags[tags.length - 1]);
    }
  };
  const unused = suggestions.filter((s) => !tags.includes(s));
  return (
    <div>
      <FieldLabel htmlFor="rn-tags">Tags</FieldLabel>
      <div className="flex min-h-[40px] flex-wrap items-center gap-1.5 rounded-md border border-slate-300 bg-white px-2 py-1.5 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 dark:border-slate-600 dark:bg-slate-900 dark:focus-within:border-sky-400 dark:focus-within:ring-sky-400">
        {tags.map((tag) => (
          <span key={tag} className="inline-flex items-center gap-1 rounded-full bg-slate-100 py-0.5 pl-2.5 pr-1 text-xs font-semibold text-slate-700 dark:bg-slate-700 dark:text-slate-200">
            {tag}
            <button type="button" aria-label={`Remove tag ${tag}`} onClick={() => onRemove(tag)} className="rounded-full p-0.5 hover:bg-slate-200 dark:hover:bg-slate-600">
              <XMarkIcon className="h-3 w-3" aria-hidden />
            </button>
          </span>
        ))}
        <input
          id="rn-tags"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={onKeyDown}
          onBlur={commit}
          placeholder={tags.length ? '' : 'Add a tag, press Enter'}
          className="min-w-[140px] flex-1 bg-transparent text-sm text-slate-900 placeholder-slate-400 outline-none dark:text-slate-100 dark:placeholder-slate-500"
        />
      </div>
      {unused.length ? (
        <p className="mt-1.5 flex flex-wrap items-center gap-1 text-xs text-slate-500 dark:text-slate-400">
          Existing tags:
          {unused.map((s) => (
            <button key={s} type="button" onClick={() => onAdd(s)} className="rounded px-1 font-semibold text-blue-600 hover:underline dark:text-sky-400">
              {s}
            </button>
          ))}
        </p>
      ) : null}
    </div>
  );
};

export default TagsInput;
